import { Routes } from '@angular/router';
import { AnonymousGuard } from '@core/guards/anonymous.guard';
import { AuthenticatedGuard } from '@core/guards/authenticated.guard';
import { isWelcomeCompletedGuard } from '@core/guards/is-welcome-completed-guard';
import { isWelcomeNotCompletedGuard } from '@core/guards/is-welcome-not-completed-guard';
import { IsAllowForRoles } from '@core/guards/is-allow-for-roles.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'asset-library'
  },
  {
    canActivate: [AnonymousGuard],
    path: 'auth/login',
    title: 'Login',
    loadComponent: () => import('./auth/features/login/login.component').then(c => c.LoginComponent)
  },
  {
    path: 'asset-library',
    canActivate: [AuthenticatedGuard, isWelcomeCompletedGuard],
    loadChildren: () => import('./features/asset-library/asset-library.route').then(r => r.AssetLibraryRoutes)
  },
  {
    path: 'user-management',
    title: 'Manage Users',
    canActivate: [AuthenticatedGuard, IsAllowForRoles(['Admin', 'SuperAdmin'])],
    loadChildren: () => import('./features/user-management/user-management.route').then(r => r.UserManagementRoutes)
  },
  {
    path: 'welcome',
    canActivate: [AuthenticatedGuard, isWelcomeNotCompletedGuard],
    loadComponent: () => import('./features/welcome/welcome.component').then(c => c.WelcomeComponent)
  },
  {
    path: 'help-center',
    loadComponent: () => import('./features/help-center/help-center.component').then(c => c.HelpCenterComponent)
  },
  {
    path: 'system-logs',
    loadComponent: () => import('./features/system-log/system-log.component').then(c => c.SystemLogComponent)
  },
  {
    path: '**',
    redirectTo: 'asset-library'
  }
];
